import React , { useState, useEffect }  from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { actionsRest } from './utils/getActions';

const Actions = ({ order, status, fetchOrders, roleName, setIsDelete }) => {

  const [actionList, setActionList] = useState(_.get(actionsRest, status, []));

  useEffect(() => {
      if (order.isFlag) {
        setActionList(actionList.filter(item => item.name !== 'RequestOrderReturn'))
      }
  }, []);
 
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      { actionList.map(Action => (
        <Action
          status={status}
          orderData={order}
          fetchOrders={fetchOrders}
          roleName={roleName}
          setIsDelete={setIsDelete}
        />
      )
      )}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
